import windowLocation from './windowLocation';

const isLoggedIn = () => {
  return !!window.localStorage.getItem('isLoggedIn');
};

const login = () => {
  window.sessionStorage.removeItem('atlas-widget-geo-location');
  window.localStorage.setItem('isLoggedIn', true);
};

const logout = () => {
  window.localStorage.removeItem('isLoggedIn');
  windowLocation.assign('/logout');
};

const routerHelpers = {
  requireAuth: (nextState) => {
    if (!isLoggedIn()) {
      windowLocation.assign(`/login?ref=${window.encodeURIComponent(nextState.location.pathname)}`);
    }
  }
};

export default { isLoggedIn, login, logout, routerHelpers };
export { isLoggedIn, login, logout, routerHelpers };
